// import React from 'react';
// import singalblog from '../Images/singalblock.avif'
// import FlipCard from '../Components/FlipCard';
// import type1img from '../Images/blocksnewimg/20-25pergectshape.png';
// import type2img from '../Images/blocksnewimg/multibgremove.png';
// import type3img from '../Images/blocksnewimg/round25mm.png';
// import type4img from '../Images/T4round40.png';
// import type5img from '../Images/blocksnewimg/footing50mmnewsharp-removebg-preview.png';
// import type6img from '../Images/blocksnewimg/plaindoorframe.png';
// import type7img from '../Images/blocksnewimg/maharajadoorframe.png';
// import type8img from '../Images/blocksnewimg/30mm round bgremove.png';
// import type9img from '../Images/blocksnewimg/50mm round bgremove.png';



// const Products = () => {

//     //   const boldKeywords = ['Size', 'Material', 'Color', 'Shape', 'Grade of Material', 'Bag of Nos', 'Box of Nos'];

//     const productList = [
//         {
//             image: type1img,
//             title: "Type 01: 20-25",
//             details: `➤ Size: 20-25mm\n ➤ Material:concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Square\n ➤ Grade:	Grey (natural)\n ➤ Contents per Bag: 300 pcs	\n ➤ Contents per Box: :100 pcs \n `,
//         },
//         {
//             image: type2img,
//             title: "Type 02:  20,25,40,50",
//             details: `➤ Size: 20x25x40x50 mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Hexagon\n ➤ Grade:	M40\n ➤ Contents per Bag: 250 pcs	\n ➤ Contents per Box: 100 pcs	\n `,
//         },
//         {
//             image: type3img,
//             title: "Type 03: Round 25",
//             details: `➤ Thickness: 25mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Round\n ➤ Grade:	M40\n ➤ Contents per Bag: 200 pcs	\n  `,
//         },
//         {
//             image: type8img,
//             title: "Type 04: Round 30",
//             details: `➤ Thickness: 30mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Round\n ➤ Grade:	M40\n ➤ Contents per Bag: 100 pcs	\n  `,
//         },
//         {
//             image: type4img,
//             title: "Type 05: Round 40",
//             details: `➤ Thickness: 40mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Round\n ➤ Grade:	M40\n ➤ Contents per Bag: 100 pcs	\n  `,
//         },
//         {
//             image: type9img,
//             title: "Type 06: Round 50",
//             details: `➤ Thickness: 50mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Round\n ➤ Grade:	M40\n ➤ Contents per Bag: 50 pcs	\n  `,
//         },

//         {
//             image: type5img,
//             title: "Type 07: 50mm Footing",
//             details: `➤ Size: 50mm\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: Rectangular\n ➤ Grade:	M40\n ➤ Contents per Bag: 100 pcs	\n ➤ Contents per Box:Not applicable (N/A) 	\n `,
//         },
//         {
//             image: type6img,
//             title: "Plain Door Frame  (4-inch Width)",
//             // details: `➤ Size:\n 7ft x 2.5ft.\n7ft x 3ft.\n 7ft x 3.25ft.\n7ft x 3.5ft.\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Shape: \n ➤ Grade:	M40\n ➤ Contents per Bag:	\n ➤ Box of Nos:	\n `,
//             details: `➤ Size:\n 7ft x 2.5ft.\n7ft x 3ft.\n 7ft x 3.25ft.\n7ft x 3.5ft.\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Grade:	M40\n ➤ Contents per Bag:Not applicable (N/A)	\n ➤ Contents per Box:Not applicable (N/A)	\n `,
//         },
//         {
//             image: type7img,
//             title: "Maharaja Door Frame (5-inch Width)",
//             details: `➤ Size:\n7ft x 3 ft.\n 7ft x 3.5 ft.\n ➤ Material: Concrete\n ➤ Color: Grey (natural)\n ➤ Grade:	M40\n ➤ Contents per Bag:Not applicable (N/A)	\n ➤ Contents per Box:Not applicable (N/A)	\n `,

//         },

//     ];

//     return (
//         <div style={{}}>
//             <h1 style={{ fontSize: 30, textAlign: "center", textDecoration: "underline", textDecorationColor: '#ff6500', color: '#121e4b', textDecorationThickness: "2px", textUnderlineOffset: "10px", letterSpacing: "5px", }}>PRODUCTS</h1>



//             <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', gap: 30, }}>
//                 {productList.map((product, index) => (
//                     <FlipCard
//                         key={index}
//                         image={product.image}
//                         title={product.title}
//                         details={product.details}
//                     />
//                 ))}
//             </div>



//         </div>
//     );
// };

// const styles = {

// };

// export default Products;




import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import type1img from '../Images/blocksnewimg/20-25pergectshape.png';
import type2img from '../Images/blocksnewimg/multibgremove.png';
import type3img from '../Images/blocksnewimg/round25mm.png';
import type4img from '../Images/T4round40.png';
import type5img from '../Images/blocksnewimg/footing50mmnewsharp-removebg-preview.png';
import type6img from '../Images/blocksnewimg/plaindoorframe.png';
import type7img from '../Images/blocksnewimg/maharajadoorframe.png';
import type8img from '../Images/blocksnewimg/30mm round bgremove.png';
import type9img from '../Images/blocksnewimg/50mm round bgremove.png';


const Products = () => {

    const [isMobile, setIsMobile] = useState(
        window.innerWidth <= 768
    );

    const [flippedCard, setFlippedCard] = useState(null);

    /* =========================================
       PRODUCT DATA
    ========================================= */

    const productList = [

        {
            image: type1img,
            title: 'Type 01: 20-25',
            category: 'Concrete Cover Block',
            details: [
                ['Size', '20-25 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Square'],
                ['Grade', 'M40'],
                ['Contents per Bag', '300 pcs'],
                ['Contents per Box', '100 pcs'],
            ],
        },

        {
            image: type2img,
            title: 'Type 02: 20, 25, 40, 50',
            category: 'Concrete Cover Block',
            details: [
                ['Size', '20 × 25 × 40 × 50 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Hexagon'],
                ['Grade', 'M40'],
                ['Contents per Bag', '250 pcs'],
                ['Contents per Box', '100 pcs'],
            ],
        },

        {
            image: type3img,
            title: 'Type 03: Round 25',
            category: 'Round Cover Block',
            details: [
                ['Thickness', '25 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Round'],
                ['Grade', 'M40'],
                ['Contents per Bag', '200 pcs'],
            ],
        },

        {
            image: type8img,
            title: 'Type 04: Round 30',
            category: 'Round Cover Block',
            details: [
                ['Thickness', '30 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Round'],
                ['Grade', 'M40'],
                ['Contents per Bag', '100 pcs'],
            ],
        },

        {
            image: type4img,
            title: 'Type 05: Round 40',
            category: 'Round Cover Block',
            details: [
                ['Thickness', '40 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Round'],
                ['Grade', 'M40'],
                ['Contents per Bag', '100 pcs'],
            ],
        },

        {
            image: type9img,
            title: 'Type 06: Round 50',
            category: 'Round Cover Block',
            details: [
                ['Thickness', '50 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Round'],
                ['Grade', 'M40'],
                ['Contents per Bag', '50 pcs'],
            ],
        },

        {
            image: type5img,
            title: 'Type 07: 50mm Footing',
            category: 'Footing Cover Block',
            details: [
                ['Size', '50 mm'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Shape', 'Rectangular'],
                ['Grade', 'M40'],
                ['Contents per Bag', '100 pcs'],
                ['Contents per Box', 'N/A'],
            ],
        },

        {
            image: type6img,
            title: 'Plain Door Frame',
            category: '4-inch Width',
            details: [
                ['Size', '7ft × 2.5ft'],
                ['Size', '7ft × 3ft'],
                ['Size', '7ft × 3.25ft'],
                ['Size', '7ft × 3.5ft'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Grade', 'M40'],
                ['Contents per Bag', 'N/A'],
                ['Contents per Box', 'N/A'],
            ],
        },

        {
            image: type7img,
            title: 'Maharaja Door Frame',
            category: '5-inch Width',
            details: [
                ['Size', '7ft × 3ft'],
                ['Size', '7ft × 3.5ft'],
                ['Material', 'Concrete'],
                ['Color', 'Grey (Natural)'],
                ['Grade', 'M40'],
                ['Contents per Bag', 'N/A'],
                ['Contents per Box', 'N/A'],
            ],
        },

    ];


    /* =========================================
       RESPONSIVE
    ========================================= */

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener(
                'resize',
                handleResize
            );
        };

    }, []);


    /* =========================================
       FLIP HANDLER
    ========================================= */

    const handleFlip = (index) => {

        if (isMobile) {

            setFlippedCard(
                flippedCard === index
                    ? null
                    : index
            );

        }

    };


    return (

        <section
            id="product"
            style={styles.section}
        >

            {/* =====================================
                BACKGROUND DECORATION
            ====================================== */}

            <div style={styles.backgroundCircleOne} />

            <div style={styles.backgroundCircleTwo} />


            {/* =====================================
                SECTION HEADER
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    y: 40,
                }}
                whileInView={{
                    opacity: 1,
                    y: 0,
                }}
                viewport={{
                    once: true,
                    amount: 0.2,
                }}
                transition={{
                    duration: 0.7,
                }}
                style={styles.sectionHeader}
            >

                <div style={styles.smallLabel}>

                    <span style={styles.labelLine} />

                    OUR PRODUCTS

                    <span style={styles.labelLine} />

                </div>


                <h1 style={styles.heading}>

                    Built for
                    <span style={styles.orangeText}>
                        {' '}Strength
                    </span>

                </h1>


                <p style={styles.subtitle}>

                    Precision-engineered concrete products designed
                    to deliver reliability, durability and consistent
                    performance across every project.

                </p>


                {/* Product count */}

                <div style={styles.productCount}>

                    <span style={styles.countNumber}>
                        {String(productList.length).padStart(2, '0')}
                    </span>

                    <span style={styles.countText}>
                        PRODUCT VARIANTS
                    </span>

                </div>

            </motion.div>


            {/* =====================================
                PRODUCT GRID
            ====================================== */}

            <div
                style={{
                    ...styles.productGrid,
                    ...(isMobile
                        ? styles.productGridMobile
                        : {}),
                }}
            >

                {productList.map((product, index) => (

                    <ProductCard
                        key={index}
                        product={product}
                        index={index}
                        isMobile={isMobile}
                        isFlipped={
                            flippedCard === index
                        }
                        onFlip={() =>
                            handleFlip(index)
                        }
                    />

                ))}

            </div>


            {/* =====================================
                BOTTOM MESSAGE
            ====================================== */}

            <motion.div
                initial={{
                    opacity: 0,
                    y: 25,
                }}
                whileInView={{
                    opacity: 1,
                    y: 0,
                }}
                viewport={{
                    once: true,
                }}
                transition={{
                    delay: 0.2,
                    duration: 0.6,
                }}
                style={styles.bottomMessage}
            >

                <div style={styles.bottomIcon}>
                    ✓
                </div>

                <div>

                    <div style={styles.bottomTitle}>
                        Quality You Can Build On
                    </div>

                    <div style={styles.bottomText}>
                        Manufactured with precision for
                        dependable construction performance.
                    </div>

                </div>

            </motion.div>

        </section>

    );
};


/* =========================================
   PRODUCT CARD
========================================= */

const ProductCard = ({
    product,
    index,
    isMobile,
    isFlipped,
    onFlip,
}) => {

    const [hovered, setHovered] = useState(false);


    return (

        <motion.div
            initial={{
                opacity: 0,
                y: 60,
            }}
            whileInView={{
                opacity: 1,
                y: 0,
            }}
            viewport={{
                once: true,
                amount: 0.12,
            }}
            transition={{
                duration: 0.65,
                delay: (index % 3) * 0.1,
                ease: [0.22, 1, 0.36, 1],
            }}
            style={styles.cardWrapper}
            onMouseEnter={() =>
                !isMobile && setHovered(true)
            }
            onMouseLeave={() =>
                !isMobile && setHovered(false)
            }
            onClick={onFlip}
        >

            {/* =====================================
                CARD
            ====================================== */}

            <motion.div
                animate={{
                    rotateY:
                        isMobile
                            ? isFlipped
                                ? 180
                                : 0
                            : hovered
                                ? 180
                                : 0,

                    y:
                        !isMobile && hovered
                            ? -8
                            : 0,
                }}
                transition={{
                    rotateY: {
                        duration: 0.7,
                        ease: [0.22, 1, 0.36, 1],
                    },

                    y: {
                        duration: 0.3,
                    },
                }}
                style={styles.card}
            >


                {/* =====================================
                    FRONT
                ====================================== */}

                <div style={styles.cardFace}>

                    {/* Product number */}

                    <div style={styles.productNumber}>
                        {String(index + 1).padStart(2, '0')}
                    </div>


                    {/* Category */}

                    <div style={styles.categoryBadge}>

                        <span style={styles.categoryDot} />

                        {product.category}

                    </div>


                    {/* Image area */}

                    <div style={styles.imageContainer}>

                        <motion.img
                            src={product.image}
                            alt={product.title}
                            style={styles.productImage}
                            animate={{
                                scale:
                                    hovered
                                        ? 1.08
                                        : 1,
                            }}
                            transition={{
                                duration: 0.5,
                            }}
                        />

                    </div>


                    {/* Product title */}

                    <div style={styles.cardBottom}>

                        <h2 style={styles.productTitle}>
                            {product.title}
                        </h2>


                        <div style={styles.viewDetails}>

                            <span>
                                View Specifications
                            </span>

                            <motion.span
                                animate={{
                                    x:
                                        hovered
                                            ? 5
                                            : 0,
                                }}
                            >
                                →
                            </motion.span>

                        </div>

                    </div>


                    {/* Bottom accent */}

                    <div style={styles.cardAccent} />

                </div>


                {/* =====================================
                    BACK
                ====================================== */}

                <div
                    style={{
                        ...styles.cardFace,
                        ...styles.cardBack,
                    }}
                >

                    <div style={styles.backHeader}>

                        <div>

                            <div style={styles.backSmallTitle}>
                                PRODUCT
                            </div>

                            <h2 style={styles.backTitle}>
                                Specifications
                            </h2>

                        </div>


                        <div style={styles.backNumber}>
                            {String(index + 1).padStart(2, '0')}
                        </div>

                    </div>


                    {/* Specifications */}

                    <div style={styles.specList}>

                        {product.details.map(
                            ([label, value], detailIndex) => (

                                <motion.div
                                    key={detailIndex}
                                    style={styles.specRow}
                                    initial={{
                                        opacity: 0,
                                        x: -10,
                                    }}
                                    animate={{
                                        opacity: 1,
                                        x: 0,
                                    }}
                                    transition={{
                                        delay:
                                            0.25 +
                                            detailIndex *
                                            0.04,
                                    }}
                                >

                                    <div style={styles.specLabel}>
                                        {label}
                                    </div>

                                    <div style={styles.specValue}>
                                        {value}
                                    </div>

                                </motion.div>

                            )
                        )}

                    </div>


                    {/* Back footer */}

                    <div style={styles.backFooter}>

                        <span>
                            STRUCTGUARD
                        </span>

                        <span>
                            ENGINEERED FOR PERFORMANCE
                        </span>

                    </div>


                    <div style={styles.cardAccent} />

                </div>

            </motion.div>

        </motion.div>

    );
};


/* =========================================
   INLINE STYLES
========================================= */

const styles = {


    /* =====================================
       SECTION
    ====================================== */

    section: {
        position: 'relative',

        width: '100%',

        minHeight: '100vh',

        padding:
            '90px 6% 80px 6%',

        boxSizing: 'border-box',

        background:
            'linear-gradient(180deg, #ffffff 0%, #f8fafb 100%)',

        overflow: 'hidden',

        fontFamily:
            'Inter, Arial, Helvetica, sans-serif',
    },


    /* =====================================
       BACKGROUND DECORATION
    ====================================== */

    backgroundCircleOne: {
        position: 'absolute',

        width: '450px',
        height: '450px',

        borderRadius: '50%',

        background:
            'rgba(242,107,33,0.035)',

        top: '-180px',
        right: '-180px',

        pointerEvents: 'none',
    },


    backgroundCircleTwo: {
        position: 'absolute',

        width: '350px',
        height: '350px',

        borderRadius: '50%',

        border:
            '1px solid rgba(242,107,33,0.07)',

        bottom: '-180px',
        left: '-150px',

        pointerEvents: 'none',
    },


    /* =====================================
       HEADER
    ====================================== */

    sectionHeader: {
        position: 'relative',

        zIndex: 2,

        textAlign: 'center',

        maxWidth: '760px',

        margin:
            '0 auto 55px auto',
    },


    smallLabel: {
        display: 'flex',

        alignItems: 'center',

        justifyContent: 'center',

        gap: '12px',

        color: '#f26b21',

        fontSize: '11px',

        fontWeight: '800',

        letterSpacing: '2.5px',

        marginBottom: '14px',
    },


    labelLine: {
        width: '32px',

        height: '2px',

        background: '#f26b21',

        borderRadius: '10px',
    },


    heading: {
        margin: 0,

        color: '#17232b',

        fontSize:
            'clamp(38px, 5vw, 58px)',

        lineHeight: '1.1',

        letterSpacing: '-2px',

        fontWeight: '800',
    },


    orangeText: {
        color: '#f26b21',
    },


    subtitle: {
        maxWidth: '620px',

        margin:
            '18px auto 0 auto',

        color: '#69747c',

        fontSize: '15px',

        lineHeight: '1.7',
    },


    productCount: {
        display: 'inline-flex',

        alignItems: 'center',

        gap: '10px',

        marginTop: '22px',

        padding:
            '7px 13px',

        border:
            '1px solid #e7ebed',

        borderRadius: '50px',

        background: '#ffffff',

        boxShadow:
            '0 5px 18px rgba(20,30,40,0.04)',
    },


    countNumber: {
        color: '#f26b21',

        fontSize: '13px',

        fontWeight: '800',
    },


    countText: {
        color: '#7b858c',

        fontSize: '9px',

        fontWeight: '700',

        letterSpacing: '1.2px',
    },


    /* =====================================
       PRODUCT GRID
    ====================================== */

    productGrid: {
        position: 'relative',

        zIndex: 2,

        width: '100%',

        maxWidth: '1250px',

        margin: '0 auto',

        display: 'grid',

        gridTemplateColumns:
            'repeat(3, minmax(0, 1fr))',

        gap: '28px',
    },


    productGridMobile: {
        gridTemplateColumns:
            '1fr',

        maxWidth: '430px',

        margin: '0 auto',
    },


    /* =====================================
       CARD WRAPPER
    ====================================== */

    cardWrapper: {
        width: '100%',

        height: '430px',

        perspective: '1200px',

        cursor: 'pointer',
    },


    /* =====================================
       CARD
    ====================================== */

    card: {
        position: 'relative',

        width: '100%',
        height: '100%',

        transformStyle: 'preserve-3d',

        borderRadius: '20px',

        boxShadow:
            '0 12px 40px rgba(25,35,42,0.08)',
    },


    cardFace: {
        position: 'absolute',

        inset: 0,

        width: '100%',
        height: '100%',

        boxSizing: 'border-box',

        backfaceVisibility: 'hidden',

        WebkitBackfaceVisibility: 'hidden',

        overflow: 'hidden',

        borderRadius: '20px',

        background: '#ffffff',

        border:
            '1px solid rgba(225,230,233,0.9)',
    },


    /* =====================================
       PRODUCT NUMBER
    ====================================== */

    productNumber: {
        position: 'absolute',

        top: '17px',
        left: '18px',

        zIndex: 5,

        width: '35px',
        height: '35px',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '10px',

        background:
            'rgba(255,255,255,0.9)',

        border:
            '1px solid #e9edef',

        color: '#f26b21',

        fontSize: '11px',

        fontWeight: '800',

        boxShadow:
            '0 5px 15px rgba(0,0,0,0.05)',
    },


    /* =====================================
       CATEGORY
    ====================================== */

    categoryBadge: {
        position: 'absolute',

        top: '20px',
        right: '18px',

        zIndex: 5,

        display: 'flex',

        alignItems: 'center',

        gap: '6px',

        padding:
            '6px 9px',

        borderRadius: '50px',

        background: '#fff7f2',

        color: '#c85b20',

        fontSize: '8px',

        fontWeight: '700',

        letterSpacing: '0.5px',

        maxWidth: '145px',

        whiteSpace: 'nowrap',

        overflow: 'hidden',

        textOverflow: 'ellipsis',
    },


    categoryDot: {
        width: '5px',
        height: '5px',

        flexShrink: 0,

        borderRadius: '50%',

        background: '#f26b21',
    },


    /* =====================================
       IMAGE
    ====================================== */

    imageContainer: {
        position: 'absolute',

        top: '63px',
        left: '20px',
        right: '20px',

        height: '245px',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '15px',

        background:
            'linear-gradient(145deg, #fafbfc, #f3f5f6)',

        overflow: 'hidden',
    },


    productImage: {
        width: '90%',
        height: '90%',

        objectFit: 'contain',

        display: 'block',
    },


    /* =====================================
       CARD BOTTOM
    ====================================== */

    cardBottom: {
        position: 'absolute',

        left: '22px',
        right: '22px',

        bottom: '25px',
    },


    productTitle: {
        margin: 0,

        color: '#17232b',

        fontSize: '17px',

        fontWeight: '750',

        lineHeight: '1.3',

        paddingRight: '10px',
    },


    viewDetails: {
        marginTop: '11px',

        display: 'flex',

        alignItems: 'center',

        justifyContent: 'space-between',

        color: '#f26b21',

        fontSize: '10px',

        fontWeight: '700',

        letterSpacing: '0.5px',

        textTransform: 'uppercase',
    },


    /* =====================================
       ORANGE ACCENT
    ====================================== */

    cardAccent: {
        position: 'absolute',

        bottom: 0,
        left: 0,

        width: '100%',

        height: '3px',

        background:
            'linear-gradient(90deg, #f26b21, #ff9b65)',

        borderRadius:
            '0 0 20px 20px',
    },


    /* =====================================
       BACK
    ====================================== */

    cardBack: {
        transform:
            'rotateY(180deg)',

        padding: '24px',

        display: 'flex',

        flexDirection: 'column',
    },


    backHeader: {
        display: 'flex',

        alignItems: 'flex-start',

        justifyContent: 'space-between',

        paddingBottom: '14px',

        borderBottom:
            '1px solid #edf0f2',
    },


    backSmallTitle: {
        color: '#f26b21',

        fontSize: '8px',

        fontWeight: '800',

        letterSpacing: '1.8px',

        marginBottom: '4px',
    },


    backTitle: {
        margin: 0,

        color: '#17232b',

        fontSize: '20px',

        fontWeight: '800',
    },


    backNumber: {
        color: '#e6e9eb',

        fontSize: '32px',

        lineHeight: 1,

        fontWeight: '800',
    },


    /* =====================================
       SPECIFICATIONS
    ====================================== */

    specList: {
        marginTop: '15px',

        display: 'flex',

        flexDirection: 'column',

        gap: '5px',

        flex: 1,

        overflowY: 'auto',

        paddingRight: '3px',
    },


    specRow: {
        display: 'grid',

        gridTemplateColumns:
            '42% 58%',

        alignItems: 'center',

        minHeight: '30px',

        padding:
            '4px 8px',

        borderRadius: '7px',

        background:
            '#f8fafb',
    },


    specLabel: {
        color: '#7a858c',

        fontSize: '9px',

        fontWeight: '700',

        letterSpacing: '0.2px',
    },


    specValue: {
        color: '#25323a',

        fontSize: '10px',

        fontWeight: '700',

        textAlign: 'right',

        wordBreak: 'break-word',
    },


    /* =====================================
       BACK FOOTER
    ====================================== */

    backFooter: {
        display: 'flex',

        alignItems: 'center',

        justifyContent: 'space-between',

        paddingTop: '12px',

        marginTop: '8px',

        borderTop:
            '1px solid #edf0f2',

        color: '#a0a8ad',

        fontSize: '7px',

        fontWeight: '700',

        letterSpacing: '1px',
    },


    /* =====================================
       BOTTOM MESSAGE
    ====================================== */

    bottomMessage: {
        position: 'relative',

        zIndex: 2,

        maxWidth: '560px',

        margin:
            '60px auto 0 auto',

        display: 'flex',

        alignItems: 'center',

        gap: '14px',

        padding:
            '14px 18px',

        border:
            '1px solid #e9edef',

        borderRadius: '14px',

        background: '#ffffff',

        boxShadow:
            '0 8px 30px rgba(25,35,42,0.05)',
    },


    bottomIcon: {
        width: '34px',
        height: '34px',

        flexShrink: 0,

        borderRadius: '50%',

        display: 'flex',

        alignItems: 'center',
        justifyContent: 'center',

        background: '#fff3eb',

        color: '#f26b21',

        fontWeight: '800',

        fontSize: '14px',
    },


    bottomTitle: {
        color: '#25323a',

        fontSize: '12px',

        fontWeight: '800',

        marginBottom: '3px',
    },


    bottomText: {
        color: '#8a949a',

        fontSize: '10px',

        lineHeight: '1.4',
    },

};


export default Products;



